import { builder } from '@ogury/unmarshaller';

export const unmarshaller = {
  expandButton: builder.holder({
    visible: builder.boolean('expand_button_visible', { defaultValue: true })
  })
};
